module.exports = __webpack_public_path__ + "u18.no2.b91359bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u18.no2.jpg
// module id = TaSd
// module chunks = 0